export const CREATE_PROSPECT = 'CREATE_PROSPECT';
export const CREATE_PROVIDER = 'CREATE_PROVIDER';
export const SET_PROVIDERS = 'SET_PROVIDERS';
export const SET_MAP = 'SET_MAP';
export const SET_AREA = 'SET_AREA';
export const SET_POLYGONS = 'SET_POLYGONS';
export const SET_COORDINATES = 'SET_COORDINATES';
export const CENTER_MAP = 'CENTER_MAP';
export const SET_CENTER_MAP = 'SET_CENTER_MAP';
export const SET_ZOOM = 'SET_ZOOM';
export const SET_EDITING_AREA = 'SET_EDITING_AREA';
export const LOGOUT = 'LOGOUT';
export const LOGIN = 'LOGIN';
export const PROSPECT_FINISHED = 'PROSPECT_FINISHED';
export const UNSET_PROSPECT = 'UNSET_PROSPECT';
export const ADDRESS_SELECTED = 'ADDRESS_SELECTED';
export const INIT_PROSPECT = 'INIT_PROSPECT';
export const UNSET_COORDINATES = 'UNSET_COORDINATES';
export const SET_LOCAL_INIT = 'SET_LOCAL_INIT';
export const PROSPECT_SHOW = 'PROSPECT_SHOW';
export const GET_AREAS = 'GET_AREAS';
export const GET_TABLE_AREAS = 'GET_TABLE_AREAS';
export const SET_AREAS = 'SET_AREAS';
export const DELETE_AREAS = 'DELETE_AREAS';
export const DELETE_AREA = 'DELETE_AREA';
export const UPDATE_AREAS = 'UPDATE_AREAS';
export const UPDATE_AREA = 'UPDATE_AREA';
export const UPDATE_PROVIDER = 'UPDATE_PROVIDER';
export const SET_PROVIDER = 'SET_PROVIDER';
export const SAVE_KM = 'SAVE_KM';
export const SET_KM = 'SET_KM';
export const GET_DASHDATA = 'GET_DASHDATA';
export const SET_DASHDATA = 'SET_DASHDATA';
export const CANCEL_PROSPECTS = 'CANCEL_PROSPECTS';
export const CHANGE_COORD = 'CHANGE_COORD';
export const GET_PROFILE = 'GET_PROFILE';
export const SET_LOCALE = 'SET_LOCALE';
export const SET_PROSPECT = 'SET_PROSPECT';
export const SET_AGENTS = 'SET_AGENTS';
export const GET_AGENTS = 'GET_AGENTS';
export const SAVE_AGENT = 'SAVE_AGENT';
export const LOGIN_AGENTS = 'LOGIN_AGENTS';
export const CHANGE_PASSWORD = 'CHANGE_PASSWORD';
export const MAIL_RECOVER = 'MAIL_RECOVER';
export const CREATE_USER = 'CREATE_USER';
export const SET_USER = 'SET_USER';
export const UPDATE_USER = 'UPDATE_USER';
export const SET_LOGIN_DATA = 'SET_LOGIN_DATA';
export const SET_COUPON = 'SET_COUPON';
export const CREATE_PAYMENT_SESSION = 'CREATE_PAYMENT_SESSION';
export const CREATE_TRANSACTION = 'CREATE_TRANSACTION';
export const ADD_CLICK = 'ADD_CLICK';
export const ADD_POLY = 'ADD_POLY';
export const PUSH_POLY = 'PUSH_POLY';
export const REMOVE_LAST_POLY = 'REMOVE_LAST_POLY';
export const POP_POLY = 'POP_POLY';
export const GET_POLYS = 'GET_POLYS';
export const SET_POLYS = 'SET_POLYS';
export const SET_POLYS_BACKUP = 'SET_POLYS_BACKUP';
export const SAVE_AREA = 'SAVE_AREA';
export const PUSH_AREA = 'PUSH_AREA';
export const SAVE_EDITED_AREAS = 'SAVE_EDITED_AREAS';
export const CREATE_CLIENT_SESSION = 'CREATE_CLIENT_SESSION';
export const SEND_FEEDBACK = 'SEND_FEEDBACK';
export const SET_PREVIEW_AREAS = 'SET_PREVIEW_AREAS';
export const REMOVE_PREVIEW_AREA = 'REMOVE_PREVIEW_AREA';
export const PUSH_PREVIEW_AREA = 'PUSH_PREVIEW_AREA';
export const SET_MAPPAGE = 'SET_MAPPAGE';
export const SET_GPS_ORIGINAL_LOCATION = 'SET_GPS_ORIGINAL_LOCATION';
export const BACK_TO_GPS = 'BACK_TO_GPS';
export const UPDATE_PROSPECT = 'UPDATE_PROSPECT';
export const SET_APIKEY = 'SET_APIKEY';
export const GET_APIKEY = 'GET_APIKEY';
export const CREATE_APIKEY = 'CREATE_APIKEY';
export const CREATE_INTEGRATION = 'CREATE_INTEGRATION';
export const UPDATE_INTEGRATION = 'UPDATE_INTEGRATION';
export const DELETE_INTEGRATION = 'DELETE_INTEGRATION';
export const GET_INTEGRATIONS = 'GET_INTEGRATIONS';
export const SET_INTEGRATIONS = 'SET_INTEGRATIONS';
export const SYNC_INTEGRATION = 'SYNC_INTEGRATION';
export const GET_GENERAL_CONFIGS = 'GET_GENERAL_CONFIGS';
export const SET_GENERAL_CONFIGS = 'GET_GENERAL_CONFIGS';
export const CREATE_ACCOUNT = 'CREATE_ACCOUNT';
export const SET_ACCOUNT = 'SET_ACCOUNT';
export const GET_INTEGRATION_PAYMENT_URL = 'GET_INTEGRATION_PAYMENT_URL';
export const NEW_PROVIDER_NAME = 'NEW_PROVIDER_NAME';




